import { EyeOutlined } from '@ant-design/icons'
import { Button, Space, Table, TablePaginationConfig } from 'antd'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Incident } from '@/types'

type Props = {
  dataSource: Incident[]
  loading: boolean
  page: number
  pageSize: number
  totalItems: number
  onChange: (config: TablePaginationConfig) => void
}

const IncidentTable = ({ dataSource, loading, onChange, page, pageSize, totalItems }: Props) => {
  const { t } = useTranslation()

  const columns = [
    {
      title: t('components.pages.incident.table.id'),
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t('components.pages.incident.table.message'),
      dataIndex: 'message',
      key: 'message',
    },
    {
      title: t('components.pages.incident.table.path'),
      dataIndex: 'path',
      key: 'path',
      render: (text: string, record: Incident) => (
        <Button type="default" size="small">
          <Link to={record.path}>
            <Space size="middle">
              <EyeOutlined />
              {t('components.pages.incident.table.detail')}
            </Space>
          </Link>
        </Button>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      dataSource={dataSource}
      columns={columns}
      loading={loading}
      pagination={{
        pageSize,
        current: page,
        total: totalItems,
      }}
      onChange={onChange}
    />
  )
}
IncidentTable.displayName = 'IncidentTable'
export default IncidentTable
